import initEraHero from './components/eras/hero';
import initEraTimeline from './components/eras/timeline';
import initEraGallery from './components/eras/gallery';

const heroEl = document.querySelector('.js-hero');

if (heroEl) {
    initEraHero(heroEl);
}

const navEl = document.querySelector('.js-timeline-nav');
const timelineEl = document.querySelector('.js-timeline');

if (navEl || timelineEl) {
    initEraTimeline(navEl, timelineEl);
}

const galleryEls = document.querySelectorAll('.js-gallery-card');

if (galleryEls && galleryEls.length > 0) {
    initEraGallery(galleryEls);
}
